import LoginPage from "../views/login/LoginNursingRobot"
import HomePage from '../views/home/HomePageNursingRobot'
import WelcomePage from '../views/welcome/index'

export default {
  apiServer: process.env.VITE_BASE_API || 'https://ai.zuowei.com/iot-api/', // 线上环境
  // apiServer:'http://10.168.1.190:8090/',
  // apiServer :'http://47.106.78.60:8091', //本地环境
  theme: 'dark',
  layout: 'side',
  logo:require('../../static/img/logo_zuowei_menu.png'),
  loginTitle: 'ZUOWEI',
  systemName: '',
  copyright: 'ZuoWei All Right Reserved',
  multipage: false,
  fixSiderbar: true,
  fixHeader: true,
  color: 'rgb(24, 144, 255)',

  loginPage:LoginPage,
  homePage:HomePage,
  welcomePage:WelcomePage
}



// WEBPACK FOOTER //
// ./src/config/config-nursingrobot.js